"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartySearchResult = void 0;
var PartySearchResult = /** @class */ (function () {
    function PartySearchResult() {
    }
    return PartySearchResult;
}());
exports.PartySearchResult = PartySearchResult;
//# sourceMappingURL=PartySearchResult.js.map